(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["callout-banner"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('callout-coupon')) {
    customElements.define('callout-coupon', class extends HTMLElement {
      connectedCallback() {
        this.controller?.abort();
        this.controller = new AbortController();

        const input = this.querySelector('input');
        const button = this.querySelector('button');
        const status = this.querySelector('[role="status"]');

        if (!input || !button || !status) return;

        button.addEventListener('click', async () => {
          button.disabled = true;
          status.textContent = '';
          clearTimeout(this.resetTimer);

          let copied = false;

          try {
            await navigator.clipboard.writeText(input.value);
            copied = true;
          } catch {
            input.focus();
            input.select();
            input.setSelectionRange(0, input.value.length);

            try {
              copied = document.execCommand('copy');
            } catch {
              copied = false;
            }
          }

          if (!this.isConnected) return;

          button.disabled = false;

          if (copied) {
            button.focus();
            status.textContent = this.dataset.success;
            this.resetTimer = setTimeout(() => {
              status.textContent = '';
            }, 3000);
          } else {
            input.focus();
            input.select();
            status.textContent = this.dataset.error;
          }
        }, { signal: this.controller.signal });
      }

      disconnectedCallback() {
        this.controller?.abort();
        clearTimeout(this.resetTimer);
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
